import React from "react";

import { Grid } from "@material-ui/core";

import LayoutHeaderTitle from "components/LayoutHeaderTitle";
import AddClientModal from "screens/Clients/components/AddClientModal";
import AuthWrapper from "components/AuthWrapper";

const clientsHeaderComponents = [
  <Grid item xs={3} md={3} lg={6}>
    <LayoutHeaderTitle title={"Clients"} />
  </Grid>,
  <AuthWrapper permission={"CLIENTS.CLIENTS_CREATE"}>
    <Grid item xs={3} md={3} lg={6}>
      <div style={{ justifyContent: "flex-end", flex: 1, display: "flex" }}>
        <AddClientModal />
      </div>
    </Grid>
  </AuthWrapper>,
];

export default clientsHeaderComponents;

